import React, { FC } from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  buttonsWrap: {
    '&div': {
      width: 400,
    },
    '& button': {
      backgroundColor: 'transparent',
      color: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
      textTransform: 'none',
      width: 200,
      height: 40,
      borderRadius: 8,
    },
    '& .MuiToggleButton-root.Mui-selected': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.primary.main,
        background: theme.palette.secondary.light,
      },
    },
  },
}))

interface IToggleButtons {
  getSelectedView: (value: string) => void
}

export const ToggleButtons: FC<IToggleButtons> = ({ getSelectedView }) => {
  const classes = useStyles()
  const [view, setView] = React.useState('funds')

  const handleChange = (event: React.MouseEvent<HTMLElement>, newView: string | null) => {
    if (newView !== null) {
      setView(newView)
      getSelectedView(newView)
    }
  }

  return (
    <ToggleButtonGroup value={view} exclusive onChange={handleChange} className={classes.buttonsWrap}>
      <ToggleButton value="funds">Company Funds</ToggleButton>
      <ToggleButton value="allocation">Allocation History</ToggleButton>
    </ToggleButtonGroup>
  )
}
